/* eslint-disable react/no-children-prop */
import useExpandable from 'Hooks/useExpandable';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectVulnDetail, selectVulnDetailTags } from 'store/Manage/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import ExpandableWrapper from '../ExpandableWrapper';
import AddTagButton from './components/AddTagButton';
import TagItems from './components/TagItems';
import {
  Wrapper
} from './styled';

const TAB = 'general';
const ID = 'tags';

const Tags = () => {
  const intl = useIntl();
  const vulnTags = useSelector(selectVulnDetailTags);
  const currentVuln = useSelector(selectVulnDetail);
  const isExpanded = useExpandable(TAB, ID, vulnTags, currentVuln?._id);
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));

  if (!hasTagsFeature) return null;

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="tags" title={ intl.formatMessage({ id: 'manage.detail.tab.general.tags' }) } tab={ TAB }>
      <Wrapper>
        <TagItems />
        <AddTagButton entity="vulnDetail" />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Tags;
